import { DevelopmentalData } from "@/types/developmental";

export const age2Milestones: DevelopmentalData = {
  motor: [
    "Runs with confidence",
    "Climbs well",
    "Walks up and down stairs",
    "Kicks and throws ball",
    "Uses pencils and crayons with better control"
  ],
  language: [
    "Uses 50+ words",
    "Combines two to three words",
    "Names most familiar objects",
    "Follows two-step instructions",
    "Begins asking simple questions"
  ],
  cognitive: [
    "Completes puzzles with 3-4 pieces",
    "Matches objects by color and shape",
    "Understands basic concepts (big/small)",
    "Begins counting with understanding",
    "Engages in imaginative play"
  ],
  independent: [
    "Uses spoon and fork",
    "Helps dress/undress self",
    "Shows interest in toilet training",
    "Washes hands with help",
    "Puts toys away with guidance"
  ],
  social: [
    "Plays alongside peers",
    "Shows empathy for others",
    "Follows simple rules",
    "Expresses a range of emotions",
    "Engages in parallel play"
  ]
};